import { generateCompStylers, getStylePropsFunc } from '../../../../../../common/utils/styles';
import DropdownElement from '../../../../../../hybrid/library/DropdownElement';
import FormInput from '../../../../../form/components/form-input/FormInput/FormInput';
import { t } from '../../../../../../common/components/T';
import ExcelButton from '../../../../../excelButton/ExcelButton';
import { svgSprite } from '../../../../../../hybrid/wrappers';
import Counter from '../../../Counter';
import { useState } from 'react';
import css from './CounterHeadSelect.module.scss';

const CounterHeadSelect = ({
    setShowModal,
    transl,
    compStyles,
    screenWidth,
    textsData,
    pageSettings,
    inputGlobFilter,
    globalSearch,
    selectPageConfig,
    exportData,
    dataFiltersToUrl,
    selectMenuData,
    checkHandler,
    value
}) => {
    const componentStyles = { ...css, ...compStyles };
    const getStyleProps = (...keys) => getStylePropsFunc(componentStyles, ...keys);
    const { stylers, classes } = generateCompStylers(componentStyles);

    const [checkboxVariation, setCheckbox] = useState(false);
    const [selectMenu, setSelectMenu] = useState(false);

    return (
        <>
            <div {...getStyleProps('tableButtonsBlock', 'tableButtonsBlock', 'adminHeadWrapper')}>
                {!screenWidth && (
                    <div {...getStyleProps('flexRow', 'adminFilterTitle', 'adminFilterTitleWidth')}>
                        <p style={{ width: 'max-content' }}>
                            {textsData.globalSearthPlaceholderLabel || textsData.globalSearthPlaceholder}
                        </p>
                    </div>
                )}
                <div {...getStyleProps('flexRow', 'flexRowWidthFix')} style={{ alignItems: 'center' }}>
                    {!screenWidth && (
                        <div {...getStyleProps('searthTable')}>
                            {!pageSettings?.hideSearchInput ? (
                                <>
                                    <FormInput
                                        value={inputGlobFilter[0]}
                                        compStyle={{
                                            icon: { fill: 'var(--greyExtraDarkColor)' },
                                            wrapper: componentStyles.searthTableInput
                                        }}
                                        handlers={{
                                            onChange: (val) => {
                                                globalSearch(val);
                                            }
                                        }}
                                        search={{ type: 'onInput', icon: 'search-thin' }}
                                        placeholder={
                                            textsData.globalSearthPlaceholder ||
                                            t('gridHeader-searchUser', 'Поиск пользователя', 'widget', transl, 'gridFilter')
                                        }
                                        buttons={{
                                            global: {
                                                icon: 'sliders',
                                                handler: () => setShowModal(true)
                                            }
                                        }}
                                    />
                                </>
                            ) : (
                                <div
                                    {...getStyleProps('searthFilterOpen', 'searthFilterOpenStatic', 'formCursorPointer')}
                                    onClick={() => setShowModal(true)}
                                >
                                    {svgSprite('search-thin', getStyleProps('userSearthSvgFillGrey'))}
                                </div>
                            )}
                        </div>
                    )}
                    {pageSettings.counter && (
                        <Counter compStyles={componentStyles} data={pageSettings.counter} translation={transl} />
                    )}
                </div>
            </div>
            {
                <div
                    className={classes.selectPageWrap}
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        ...stylers.selectPageWrap
                    }}
                >
                    <div style={{ display: 'flex' }}>
                        <div {...getStyleProps('headGridLeftPart')}>
                            <div {...getStyleProps('headGridSub')}>
                                <div {...getStyleProps('selectPage', 'selectPageMod')}>
                                    <div
                                        onClick={() => {
                                            setCheckbox((pre) => {
                                                return pre !== 'selected' ? 'selected' : 'deleted';
                                            });
                                            checkHandler(checkboxVariation !== 'selected');
                                        }}
                                        style={{
                                            background: checkboxVariation ? 'var(--blueColor)' : '',
                                            ...stylers.checkboxmanual
                                        }}
                                        className={classes.checkboxmanual}
                                    >
                                        <div
                                            {...getStyleProps(
                                                checkboxVariation === 'selected'
                                                    ? 'checkedmanual'
                                                    : checkboxVariation === 'deleted'
                                                    ? 'deletedmanual'
                                                    : ''
                                            )}
                                        ></div>
                                    </div>
                                    <div
                                        onClick={() => setSelectMenu(!selectMenu)}
                                        style={{
                                            width: '20px',
                                            height: '24px',
                                            marginLeft: '8px'
                                        }}
                                    >
                                        {svgSprite('angle-down', {
                                            style: {
                                                width: '10px',
                                                height: '5px',
                                                fill: 'var(--darkColor)',
                                                transform: `rotate(${!!selectMenu ? 180 : 0}deg)`
                                            }
                                        })}
                                    </div>
                                    {selectMenu && (
                                        <div {...getStyleProps('itemsSelect')}>
                                            {selectMenuData.map(({ handler, title }) => (
                                                <p
                                                    key={`selectMenuData_${title}`}
                                                    {...getStyleProps('itemSelect')}
                                                    onClick={() => {
                                                        handler().then((disable) => {
                                                            setSelectMenu(false);
                                                            disable && setCheckbox(false);
                                                        });
                                                    }}
                                                >
                                                    {title}
                                                </p>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div {...getStyleProps('headGridSelected')}>
                                <p {...getStyleProps('selectedText')}>
                                    {t('selected-queries', 'Выделено', 'widget', transl, 'gridHeader')}:
                                </p>
                                <p {...getStyleProps('selectedCount')}>{value || '0'}</p>
                            </div>
                        </div>
                    </div>
                    <div
                        className={classes.selectPageWrap}
                        style={{
                            padding: '0',
                            zIndex: 1,
                            ...stylers.selectPageWrap
                        }}
                    >
                        <p {...getStyleProps('selectPageText')}>
                            {screenWidth
                                ? t('gridHeader-selectPageTextXs', 'Записей', 'widget', transl, 'gridHeader')
                                : t('gridHeader-sselectPageText', 'Записей на странице', 'widget', transl, 'gridHeader')}
                            :
                        </p>
                        <DropdownElement componentConfig={selectPageConfig} />
                        {exportData && (
                            <p {...getStyleProps('counterHeadExportbutton')}>
                                <ExcelButton exportData={exportData} filter={dataFiltersToUrl} />
                            </p>
                        )}
                    </div>
                </div>
            }
        </>
    );
};
export default CounterHeadSelect;
